import React from "react";

import mtzApis from "../../../services";
import AuthContext from "../../../AuthContext";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Chip from "@material-ui/core/Chip";
import ImageList from "@material-ui/core/ImageList";
import ImageListItem from "@material-ui/core/ImageListItem";
import ImageListItemBar from "@material-ui/core/ImageListItemBar";
import { makeStyles } from "@material-ui/styles";
import { NavLink } from "react-router-dom";
import AddIcon from "@material-ui/icons/Add";
import CardActions from "@material-ui/core/CardActions";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import "./style.css";

const { companyService } = mtzApis;
const useStyles = makeStyles({
  root: {
    "& .MuiImageListItem-item": {
      display: "flex",
      alignItems: "center",
      border: "1px #efefef solid",
    },
    "&": {
      flexWrap: "noWrap",
    },
  },
});

export default function ProductMenuManager({ profileName, companyId }) {
  const classes = useStyles();
  const me = React.useContext(AuthContext);
  let [menus, setMenus] = React.useState(null);
  let [products, setProducts] = React.useState(null);
  let [activeMenu, setActiveMenu] = React.useState(null);
  let [company, setCompany] = React.useState(null);
  const [menuAnchor, setMenuAnchor] = React.useState(null);
  let [productStats, setProductStats] = React.useState(null);

  React.useEffect(() => {
    init();
  }, [profileName, companyId]);

  const init = async () => {
    let myCompany = null;
    if (companyId) myCompany = await companyService.getCompanyById(companyId);
    if (profileName) {
      myCompany = await companyService.getCompanies(
        new URLSearchParams(`profileName=${profileName}`)
      );
      if (myCompany && myCompany.length > 0) myCompany = myCompany[0];
    }
    setCompany(myCompany);

    if (myCompany) {
      setCompany(myCompany);
      let menus = await companyService.getProductMenus(
        new URLSearchParams(`companyIds=${myCompany.id}`)
      );
      if (menus) setMenus(menus);
      let productStats = await companyService.getProductStats(
        new URLSearchParams(`companyIds=${myCompany.id}`)
      );
      setProductStats(productStats);

      getCompanyProducts(myCompany.id);
    }
  };

  const getMenuProducts = async (menu) => {
    let products = await companyService.getProducts(
      new URLSearchParams(`productIds=${menu.productIds}`)
    );
    if (products) {
      products = products.slice(0, 2);
      // load images
      let prodIds = products.map(s => s.id);
      let imgs = await companyService.getProductImages(new URLSearchParams(`productIds=${prodIds}&limit=${1 * prodIds.length}`));
      let imgMap = {};
      imgs.forEach(img => imgMap[img.productId] = img.path);
      products.forEach(search => search.images = [imgMap[search.id]]);
      setProducts(products);
    }
  };

  const getCompanyProducts = async (myCompanyId) => {
    products = await companyService.getProducts(new URLSearchParams(`companyIds=${myCompanyId}`));
    if (products) {
      products = products.slice(0, 2);
      // load images
      let prodIds = products.map(s => s.id);
      let imgs = await companyService.getProductImages(new URLSearchParams(`productIds=${prodIds}&limit=${1 * prodIds.length}`));
      let imgMap = {};
      imgs.forEach(img => imgMap[img.productId] = img.path);
      products.forEach(search => search.images = [imgMap[search.id]]);
      setProducts(products);

    }
  };

  return (
    <React.Fragment>
      {productStats && productStats.all.count > 0 && (
        <Card className="product-menu" elevation={0}>
          <CardHeader
            subheader={<h5 className="product-menu-text">Our products</h5>}
            action={
              me &&
              company &&
              me.userId === company.ownerId && (
                <NavLink to="/me/products/add" color="secondary">
                  <b>Add New Product</b>
                </NavLink>
              )
            }
          />
          <CardContent className="py-2">
            <div>
              {menus === null && "Loading..."}
              <div style={{ display: "inline-block", marginBottom: "1px" }}>
                <Button
                  className="product-menu product-menu-button company-product-menu"
                  endIcon={<ArrowDropDownIcon />}
                  size="medium"
                  onClick={(e) => setMenuAnchor(e.target)}
                  onClose={() => setMenuAnchor(null)}
                  variant="outlined"
                  color="primary"
                >
                  <span className="product-menu-button-font">Product Menus</span>
                </Button>
              </div>
              <Menu
                getContentAnchorEl={null}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
                onClose={() => setMenuAnchor(null)}
                open={!!menuAnchor}
                anchorEl={menuAnchor}
              >
                {menus &&
                  menus.map((menu) => (
                    <MenuItem
                      button
                      key={menu.id}
                      onClick={() => {
                        setActiveMenu(!activeMenu || activeMenu.id !== menu.id ? menu : null);
                        !activeMenu || activeMenu.id !== menu.id
                          ? getMenuProducts(menu)
                          : getCompanyProducts(company.id);
                      }}
                    >
                      {menu.name}
                    </MenuItem>
                  ))}
              </Menu>
              &nbsp;
              {me && company && me.userId === company.ownerId && (
                <div style={{ display: "inline-block" }}>
                  <Button
                    className="add-product-menu-button"
                    startIcon={<AddIcon style={{ color: "white" }} />}
                    size="medium"
                    onClick={() => (window.location.href = "/me/product-menus")}
                    variant="contained"
                    color="primary"
                    disableElevation
                  >
                    <span className="add-product-menu-button-font">Add Product Menu</span>
                  </Button>
                </div>
              )}
            </div>

            <div className="my-2">
              {products === null && "Loading..."}

              <ImageList cols={2} className={classes.root}>
                {products &&
                  products.map((product) => (
                    <ImageListItem key={product.id}>
                      <NavLink
                        target="_blank"
                        to={`/products/${company.profileName}/${product.sku}`}
                      >
                        <img
                          className="mw-100 mh-100 align-self-center"
                          src={
                            product.images && product.images.length > 0
                              ? companyService.getBackendHost() + product.images[0]
                              : "/assets/images/empty.png"
                          }
                          alt={
                            product.images && product.images.length > 0
                              ? companyService.getBackendHost() + product.images[0]
                              : "/assets/images/empty.png"
                          }
                        />
                        <ImageListItemBar title={product.name} />
                      </NavLink>
                    </ImageListItem>
                  ))}
              </ImageList>
            </div>
          </CardContent>
          <CardActions>
            {company && (
              <NavLink
                style={{ fontWeight: "bold" }}
                to={`/profile/${company.profileName}/products`}
              >
                See all products
              </NavLink>
            )}
          </CardActions>
        </Card>
      )}
    </React.Fragment>
  );
}
